import { Control, Controller } from "react-hook-form";

type FormInputProps = {
  name: string;
  control: Control;
  onSubmit: () => void;
};

const options: { label: string; value: number }[] = [
  {
    label: "10",
    value: 10,
  },
  {
    label: "15",
    value: 15,
  },
  {
    label: "30",
    value: 30,
  },
  {
    label: "50",
    value: 50,
  },
  {
    label: "100",
    value: 100,
  },
];

export const RowsDropdown: React.FC<FormInputProps> = ({ name, control, onSubmit }) => {
  const generateSingleOptions = () => {
    return options.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ));
  };

  return (
    <Controller
      render={({ field: { onChange, value } }) => (
        <div className="me-auto">
          <div className="input-group">
            <select
              className="form-select"
              id="type"
              onChange={(e) => {
                onChange(e);
                onSubmit();
              }}
              value={value}
            >
              {generateSingleOptions()}
            </select>
            <label className="input-group-text">rows per page</label>
          </div>
        </div>
      )}
      control={control}
      name={name}
    />
  );
};
